import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { adminApi } from '../../api/adminApi';
import ToolIcon from '../shared/ToolIcon/ToolIcon';
import { getToolLabel } from '../shared/toolLabels';
import './ToolManagement.css';

// 1. UNSERE FERTIGEN TOOLS
import TimesheetAdmin from '../tools/timesheet/TimesheetAdmin';
import ProjectsAdmin from '../projects/ProjectsAdmin';


// 2. DER PLATZHALTER FÜR DEN REST
import PlaceholderAdmin from '../tools/PlaceholderAdmin';

// ICONS & TEXTE
const TOOL_META = {
    'timesheet': { icon: '⏱️', desc: 'Arbeitszeiten erfassen und verwalten' },
    'journal': { icon: '📖', desc: 'Tägliche Baustellenberichte' },
    'files': { icon: '📁', desc: 'Dokumente und Pläne' },
    'photos': { icon: '📸', desc: 'Fotodokumentation' },
    'leader': { icon: '👷', desc: 'Kolonnenführung' },
    'vehicleStatus': { icon: '🚗', desc: 'Fahrzeuge verwalten und Fahrzeugstatus' },
    'internalHandover': { icon: '🔄', desc: 'Material & Info Übergabe (Interne Übergabe)' },
    'rental': { icon: '🚧', desc: 'Vermietungstool: Equipment vermieten' },
    'employee': { icon: '🧑‍💼', desc: 'Mitarbeiter verwalten und Berechtigungen' }
};

export default function ToolManagement({ onToolActivate, onOpenJournalProject }) {
    const location = useLocation();
    const [tools, setTools] = useState([]);
    const [selectedTool, setSelectedTool] = useState(null);
    const [loading, setLoading] = useState(false);
    const [view, setView] = useState('overview');

    const token = localStorage.getItem('token');

    useEffect(() => {
        fetchTools();
    }, [token]);

    useEffect(() => {
        const toolKey = location.state?.selectedToolKey || new URLSearchParams(location.search).get('tool');
        if (toolKey && tools.length > 0) {
            const tool = tools.find(t => t.tool_key === toolKey);
            if (tool) {
                handleManage(tool);
            }
        }
    }, [tools, location.state, location.search]);

    const fetchTools = async () => {
        setLoading(true);
        try {
            const data = await adminApi.getCompanyTools();
            setTools(data);
        } catch (err) { console.error(err); }
        finally { setLoading(false); }
    };

    const toggleStatus = async (tool) => {
        const newStatus = !tool.enabled;
        const actionText = newStatus ? 'AKTIVIEREN' : 'DEAKTIVIEREN';

        if (!window.confirm(`Möchtest du das Modul "${tool.tool_name}" wirklich ${actionText}?`)) {
            return;
        }

        const updatedTools = tools.map(t =>
            t.id === tool.id ? { ...t, enabled: newStatus } : t
        );
        setTools(updatedTools);

        try {
            await adminApi.updateCompanyTool(tool.tool_key, { enabled: newStatus });
        } catch (err) {
            console.error(err);
            alert("Fehler beim Speichern. Änderungen werden rückgängig gemacht.");
            fetchTools();
        }
    };

    const handleManage = (tool) => {
        setSelectedTool(tool);
        setView('manage');
        if (onToolActivate) onToolActivate(true);
    };

    const handleBack = () => {
        setView('overview');
        setSelectedTool(null);
        if (onToolActivate) onToolActivate(false);
    };

    // --- RENDER ---

    if (view === 'manage' && selectedTool) {
        if (selectedTool.tool_key === 'timesheet') {
            return (
                <div className="tool-details-wrapper">
                    <TimesheetAdmin onBack={handleBack} />
                </div>
            );
        }
        if (selectedTool.tool_key === 'journal') {
            return (
                <div className="tool-details-wrapper">
                    <ProjectsAdmin onBack={handleBack} onOpenJournalProject={onOpenJournalProject} />
                </div>
            );
        }

        return (
            <div className="tool-details-wrapper">
                <PlaceholderAdmin tool={selectedTool} onBack={handleBack} />
            </div>
        );
    }

    // FALL B: ÜBERSICHT (KACHELN)
    return (
        <div className="tool-management">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px' }}>
                <h3 style={{ margin: 0 }}>Tools & Module verwalten</h3>
            </div>

            {loading ? <p>Lade Tools...</p> : (
                <div className="tools-overview">
                    {tools.map(tool => {
                        const meta = TOOL_META[tool.tool_key] || { icon: '❓', desc: 'Keine Beschreibung' };
                        return (
                            <div key={tool.id} className="tool-overview-card">
                                <div className="tool-header">
                                    <div className="tool-icon"><ToolIcon name={tool.tool_key} mode="emoji" /></div>
                                    <div className="tool-info">
                                        <h4>{getToolLabel(tool.tool_key, tool.tool_name)}</h4>
                                        <p>{meta.desc}</p>
                                    </div>
                                </div>
                                <div className="tool-actions">
                                    <button
                                        className={`toggle-status ${tool.enabled ? 'enabled' : ''}`}
                                        onClick={() => toggleStatus(tool)}
                                    >
                                        {tool.enabled ? 'Aktiv' : 'Inaktiv'}
                                    </button>
                                    <button className="manage-btn" onClick={() => handleManage(tool)}>Verwalten</button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}